import React from "react";
import { Box, Grid, Heading, Divider } from "@chakra-ui/core";
import "react-phone-input-2/lib/high-res.css";

/** Conllecting/Rendering info about the customer (buyers) */

const CustomerDetailsView = ({ customerInfo }) => {
  return (
    <>
      <Heading mb="20px" as="h4" size="md">
        Customer
      </Heading>
<Grid bg="warning.transparent-100" borderRadius="8px" templateColumns="repeat(2, 1fr)" gap="3px">
  <Box borderTopLeftRadius="5px" bg="warning.200" color="primary.500" w="100%" p="8px">First name </Box>
  <Box p="8px" fontSize="sm">{customerInfo.firstName} </Box>
  <Box bg="warning.200" color="primary.500" p="8px">Last name </Box>
  <Box p="8px" fontSize="sm">{customerInfo.lastName} </Box>
  <Box bg="warning.200" color="primary.500" p="8px">Phone </Box>
  <Box p="8px" fontSize="sm">{customerInfo.phone} </Box>
  <Box borderBottomLeftRadius="5px" bg="warning.200" color="primary.500" p="8px">Email </Box>
  <Box p="8px" fontSize="sm">{customerInfo.email} </Box>
</Grid>

      <Divider my={6} />
    </>
  );
};

export default CustomerDetailsView;
